import styles from "./Footer.module.css";

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.footerContent}>
      <span>
        Project Funded by the{" "}
        <a
          href="https://socialsciences.cornell.edu/funding-and-programs/funding-opportunities?toptab=seed_grants&contenttab=recently_awarded_projects"
          target="_blank"
          rel="noreferrer"
        >
          Cornell Center for Social Sciences
        </a>
      </span>
      <span>Data Collection Approved Under Cornell IRB #0149464</span>
    </div>
  </footer>
);

export default Footer;
